
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["camera_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1084 1024","xmlns":"http://www.w3.org/2000/svg","width":"135.5","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M124.988 698.73V567.717c0-4.518-3.012-7.53-7.53-9.036L25.6 540.612c-6.024-1.506-10.541 1.506-10.541 7.53v454.776c0 6.023 6.023 10.54 12.047 9.035l91.859-33.13c3.011-1.505 6.023-4.517 6.023-9.035V819.2c0-4.518 4.518-9.035 9.036-9.035h164.14c3.012 0 6.024-1.506 7.53-3.012l88.847-124.988c3.012-4.518 1.506-10.541-3.012-12.047l-108.423-60.236c-4.518-3.011-10.541 0-12.047 4.518l-28.612 88.847c-1.506 3.012-4.518 6.024-9.035 6.024h-96.377c-7.53 0-12.047-4.518-12.047-10.542zm939.67-146.071l-793.6-539.106c-1.505-1.506-3.01-1.506-4.517-1.506h-85.835c-3.012 0-6.024 1.506-7.53 4.518L49.694 216.847c-1.506 1.506-1.506 3.012-1.506 4.518v63.247c0 3.012 1.506 6.023 4.518 7.53L754.447 734.87c1.506 1.505 3.012 1.505 4.518 1.505h54.211c1.506 0 3.012 0 4.518-1.505l246.965-167.153c6.023-4.518 6.023-12.047 0-15.06zm-957.74-185.224l-51.2 58.73c-3.012 4.517-3.012 10.54 1.506 13.553l692.705 447.247c1.506 1.506 3.012 1.506 4.518 1.506h58.73c3.011 0 4.517-1.506 6.023-3.012l30.118-31.624c1.506-1.506 1.506-1.506 1.506-3.011l27.105-85.836c1.506-4.517-4.517-9.035-9.035-6.023-21.082 16.564-63.247 48.188-76.8 58.73-3.012 1.505-7.53 1.505-10.541 0-19.577-13.554-40.659-25.6-61.741-36.142h-1.506L118.965 365.929c-4.518-1.505-9.036-1.505-12.047 1.506z"}})])
          )
        }
      }
    